import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    { attrs: { dense: "" } },
    [
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [_c("app-title", { attrs: { texto: _vm.titulo.toUpperCase() } })],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [
          _c(VDataTable, {
            staticClass: "elevation-0",
            attrs: {
              items: _vm.mapeamentosView,
              headers: _vm.headers,
              search: _vm.opcoes.pesquisa,
              "sort-by": _vm.opcoes.ordenarPor,
              "sort-desc": _vm.opcoes.decrescente,
              "item-key": "id",
              "show-select": _vm.isImportacao,
              "show-expand": "",
              "single-expand": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "top",
                  fn: function () {
                    return [
                      _c(
                        VRow,
                        { attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("app-sort", {
                                model: {
                                  value: _vm.opcoes,
                                  callback: function ($$v) {
                                    _vm.opcoes = $$v
                                  },
                                  expression: "opcoes",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(VCol, { attrs: { cols: "0", md: "4" } }),
                          _c(
                            VCol,
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("app-search", {
                                model: {
                                  value: _vm.opcoes,
                                  callback: function ($$v) {
                                    _vm.opcoes = $$v
                                  },
                                  expression: "opcoes",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: `header.data-table-select`,
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
                {
                  key: `item.data-table-select`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        VRadioGroup,
                        {
                          model: {
                            value: _vm.mapeamentoSelecionado,
                            callback: function ($$v) {
                              _vm.mapeamentoSelecionado = $$v
                            },
                            expression: "mapeamentoSelecionado",
                          },
                        },
                        [
                          _c(VRadio, {
                            attrs: { value: item },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("mapeamento", item)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: `item.data-table-expand`,
                  fn: function ({ item, expand, isExpanded }) {
                    return [
                      _c(
                        VTooltip,
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      VBtn,
                                      _vm._g(
                                        {
                                          attrs: {
                                            text: "",
                                            height: "100%",
                                            width: "100%",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return expand(!isExpanded)
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          VBadge,
                                          {
                                            attrs: { right: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "badge",
                                                  fn: function () {
                                                    return [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.unidades.length
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              {
                                                attrs: {
                                                  large: "",
                                                  color: "grey lighten-0",
                                                },
                                              },
                                              [_vm._v(" account_balance ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v("Clique para exibir as unidades vinculadas"),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "expanded-item",
                  fn: function ({ headers, item }) {
                    return [
                      _c(
                        "td",
                        {
                          staticClass: "justify-center",
                          attrs: { colspan: headers.length },
                        },
                        [
                          _c(
                            VRow,
                            [
                              _c(VSpacer),
                              _c(
                                VCol,
                                [
                                  _c(
                                    VRow,
                                    { staticClass: "justify-center" },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "title primary--text text--darken-1 text-no-wrap",
                                        },
                                        [_vm._v(" UNIDADES VINCULADAS ")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(VSpacer),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(VSpacer),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(VSimpleTable, {
                                    staticClass: "elevation-0 mb-4",
                                    attrs: { dense: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  item.unidades,
                                                  function (unidade) {
                                                    return _c(
                                                      "tr",
                                                      { key: unidade.id },
                                                      [
                                                        _c("td", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex flex-row ma-1",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "grey-text text--darken-2",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      `${unidade.sigla} - ${unidade.nome}`
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(VSpacer),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: `item.situacao`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        VChip,
                        {
                          staticClass: "pa-2",
                          attrs: {
                            color: item.situacao.cor,
                            small: "",
                            outlined: "",
                          },
                        },
                        [
                          _c(
                            VAvatar,
                            { attrs: { left: "" } },
                            [
                              _c(VIcon, [
                                _vm._v(_vm._s(item.situacao.icone)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" " + _vm._s(item.situacao.nome) + " "),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: `item.acoes`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        VCol,
                        [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.situacao.id ===
                                                      "AGENDADO" ||
                                                    item.situacao.id ===
                                                      "ATIVO",
                                                  expression:
                                                    "\n                  item.situacao.id === 'AGENDADO' ||\n                    item.situacao.id === 'ATIVO'\n                ",
                                                },
                                              ],
                                              staticClass: "mr-2",
                                              attrs: {
                                                icon: "",
                                                small: "",
                                                color: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editar(item)
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [_c(VIcon, [_vm._v("edit")])],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Clique no botão para editar o mapeamento"
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.situacao.id ===
                                                    "AGENDADO",
                                                  expression:
                                                    "item.situacao.id === 'AGENDADO'",
                                                },
                                              ],
                                              attrs: {
                                                icon: "",
                                                small: "",
                                                color: "error",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.confirmDelete(item)
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [_c(VIcon, [_vm._v("delete")])],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Clique no botão para excluir o mapeamento"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c("dialog-remove", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dialogs.dialogRemove.visible,
            expression: "dialogs.dialogRemove.visible",
          },
        ],
        attrs: {
          "confirm-action": _vm.deleteMapeamento,
          "dialog-visible": _vm.dialogs.dialogRemove.visible,
          "toogle-visible": _vm.toogleDialogRemove,
          descricao: _vm.mensagemExclusao,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }